

function getSavedFormData(db, formConfig, onSuccess) {
  db.transaction('rw', db.formData, async () => {
    const data = {}
    await Promise.all(Object.keys(formConfig).map(async (id) => {
      const dbData = await db.formData.get(id).catch(e => console.log(`error db get (${id})`, e))
      if(dbData){
        data[dbData.id] = dbData.value
      }
    }))
    console.log('load data', data)
    onSuccess(data)
  }).catch(e => {
    console.log(e.stack || e)
  })
}

function saveFormDataInDb(db, formValues) {
  try {
    Object.entries(formValues).map( async ([id, value]) => {
      if (value && db.formData) {
        await db.formData.put({ id, value }).catch(e => console.log('error db put', e))
      }
    })
  } catch(err) {
    console.log(err)
  }
}

function getSectionsOrderFromDb(db, onSuccess) {
  try {
    const id = 'sectionOrder'
    db.sectionOrder.get(id)
    .then((sectionOrder) => {
      console.log('load sectionOrder', sectionOrder)
      onSuccess(sectionOrder)
    })
    .catch(e => console.log('error db put', e))
  } catch(err) {
    console.log(err)
  }
}

async function saveSectionsOrderInDb(db, sectionsOrder) {
  try {
    console.log('save sectionOrder', sectionsOrder)
    const saveData = {
      id: 'sectionOrder',
      sectionOrder: sectionsOrder
    }
    await db.sectionOrder.put(saveData).catch(e => console.log('error db put', e))
  } catch(err) {
    console.log(err)
  }
}

const recalculateCompleteness = ({
  formData,
  formConfig
}) => {
  const completeness = Object.entries(formData).reduce((comp, entry) => {
    const [key, value] = entry
    const config = formConfig[key]
    if (value && config) {
      if (value.length === 0) {
        return comp
      }
      if (config.validate && typeof config.validate(value) === 'string') {
        return comp
      }
      return comp + (config.completeness || 0)
    }
    return comp
  }, 0)
  return completeness
}

export {
  getSavedFormData,
  saveFormDataInDb,
  saveSectionsOrderInDb,
  getSectionsOrderFromDb,
  recalculateCompleteness
}